<router-outlet></router-outlet>
<div *ngIf="displayChat">
    <app-chat-user-interface></app-chat-user-interface>
</div>